export const raw = (param: HTMLElement) => {
  let rawValue = '';
  rawValue += param;
  return rawValue;
};
